module.exports = __webpack_public_path__ + "media/images/new_cup-ef04de1e8696fb16e9f15c6f4cdcef4e.png";